import { isValidSalesforceId, noWhiteSpacesRegex, usZipCodeRegex, websiteRegex } from 'src/helpers';

const formFieldsConfig = {
  name: {
    name: 'name',
    placeholder: 'Owner Name',
    validationSchema: {
      required: 'Owner Name is required'
    }
  },
  salesforce_id: {
    name: 'salesforce_id',
    placeholder: 'Salesforce ID',
    validationSchema: {
      required: 'Salesforce ID is required',
      validate: {
        validSalesforceId: (value: string) =>
          !value || isValidSalesforceId(value) || 'Must be a valid 15 or 18 character Salesforce ID'
      }
    }
  },
  address: {
    name: 'address',
    placeholder: 'Street Address',
    validationSchema: {
      required: false
    }
  },
  city: {
    name: 'city',
    placeholder: 'City',
    validationSchema: {
      maxLength: {
        value: 80,
        message: 'City name should have 80 characters maximum'
      },
      required: false
    }
  },
  state: {
    name: 'state',
    placeholder: 'State',
    validationSchema: {
      required: false,
      validate: {
        areOtherAddressFieldsFilled: (value: string, formValues: any) => {
          if (!value) return true;
          const { address, city, zip } = formValues;
          return address && city && zip ? true : 'Please fill all address fields';
        }
      }
    }
  },
  zip: {
    name: 'zip',
    placeholder: 'Zip Code',
    validationSchema: {
      validate: (value: number | string) => {
        // return valid if empty
        if (!value) return true;
        return usZipCodeRegex.test(value.toString()) || 'Invalid zip code';
      },
      required: false
    }
  },
  phone: {
    name: 'phone',
    placeholder: 'Phone Number',
    validationSchema: {
      required: false
    }
  },
  website: {
    name: 'website',
    placeholder: 'Website',
    validationSchema: {
      maxLength: {
        value: 120,
        message: 'Website should have 120 characters maximum'
      },
      validate: {
        invalidWebsiteString: (value: string) =>
          value ? websiteRegex.test(value) || 'Invalid website' : undefined,
        noWhiteSpaces: (value: string) =>
          value
            ? noWhiteSpacesRegex.test(value) || 'Website should not start or end with whitespaces'
            : undefined
      }
    }
  }
};

export default formFieldsConfig;
